// FLS (Full Logging System)
window["FLS"] = false;

import * as flsFunctions from "./files/functions.js";
import * as flsScroll from "./files/scroll/scroll.js";

// Getting the height of the site header
import { getHeaderHeight } from "./utilites/header-height.js";

flsFunctions.isWebp();

//MacOS cheker
flsFunctions.setPlatformClass();
flsScroll.headerScroll();

window.addEventListener("load", function () {
  setTimeout(function () {
    flsFunctions.menuInit();
    flsFunctions.menuSublistsInit();
    flsFunctions.spollers();
    flsFunctions.tabs();

    flsForms.formFieldsInit({
      viewPass: false,
      autoHeight: false,
    });
    flsForms.formQuantity();
  }, 0);
});

flsFunctions.addTouchClass();

flsFunctions.addLoadedClass();

import "./libs/popup.js";

/*Forms*/
import * as flsForms from "./files/forms/forms.js";

flsForms.formSubmit();

import "./libs/select.js";

import "./files/forms/datepicker.js";

/* Gravity Forms select fix */
import "./files/forms/gravity-forms-select-fix.js";

/* Dynamyc adaptive */
import "./libs/dynamic_adapt.js";

/* Custom scripts */
import "./files/script.js";

/* compare cards handler */
import "./files/compare.js";

/* booking handler */
import "./files/booking.js";

/* currency handler */
import "./files/currency.js";

/* algolia handler */
import "./files/algolia.js";

/* Course feedback */
import "./files/feedback.js";

/* Country check */
import "./files/country.js";

/* Smooth scroll with offset for sticky header */
import "./files/smooth-scroll-offset.js";
